import { defineFetcher } from "~/api/_common/defineFetcher"
import { GET } from "~/api/_common/http"

const PATH = "/favorites"

export type GetFavorites = any

export const fetchGetFavorites = defineFetcher((): Promise<GetFavorites> => {
  return GET(PATH)
})
